import s from './home.module.css';

type Card = { num: string; title: string; body: string };

export default function TripleSection(props: {
  id?: string;
  label: string;
  title: string;
  lead?: string;
  cards: Card[];
  /** Optional content rendered under the cards (e.g. a "learn more" link). */
  foot?: React.ReactNode;
}) {
  return (
    <section id={props.id}>
      <div className="container">
        <span className={s.sectionLabel}>{props.label}</span>
        <h2 className={s.sectionTitle}>{props.title}</h2>
        {props.lead && <p className={s.sectionLead}>{props.lead}</p>}
        <div className={s.triple}>
          {props.cards.map((c, i) => (
            <div key={i} className={s.tripleCard}>
              <div className={s.tripleNum}>{c.num}</div>
              <h3 className={s.tripleTitle}>{c.title}</h3>
              <p className={s.tripleBody}>{c.body}</p>
            </div>
          ))}
        </div>
        {props.foot}
      </div>
    </section>
  );
}
